import React from 'react';
import { useBaseCurrency } from '../../db/hooks/useLookupData';

interface FormatCurrencyProps {
  amount: number | null | undefined;
  fallback?: string;
  className?: string;
}

export function FormatCurrency({ amount, fallback = '...', className = '' }: FormatCurrencyProps) {
  const { format, isLoading } = useBaseCurrency();

  if (isLoading) {
    return <span className={className}>{fallback}</span>;
  }

  return <span className={className}>{format(amount)}</span>;
}
